import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Checkmark.svg",
  "use": "Checkmark.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Checkmark.svg\"><path d=\"M17.667,30.855l9.7891,14.0221L48.4072,14.8664a2.0015,2.0015,0,0,1,3.05-.2779,2.0878,2.0878,0,0,1,.1714,2.6716L29.4907,48.9708a2.4822,2.4822,0,0,1-4.0694,0L14.4456,33.2489a2.088,2.088,0,0,1,.1713-2.672A2.0016,2.0016,0,0,1,17.667,30.855Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol